import { render, staticRenderFns } from "./sw-connections.vue?vue&type=template&id=8ba45e30&"
import script from "./sw-connections.vue?vue&type=script&lang=js&"
export * from "./sw-connections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports